import { render, staticRenderFns } from "./upload-img.vue?vue&type=template&id=7894de6f&scoped=true&"
import script from "./upload-img.vue?vue&type=script&lang=js&"
export * from "./upload-img.vue?vue&type=script&lang=js&"
import style0 from "./upload-img.vue?vue&type=style&index=0&id=7894de6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7894de6f",
  null
  
)

export default component.exports